export const newsList = [
  {
    id: "news-01",
    title: "《星际裂痕》口碑持续走高，太空科幻再掀观影热潮",
    category: "影视资讯",
    date: "2025-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20modern%20movie%20theater%20entrance%20at%20night%20with%20glowing%20deep%20blue%20lighting%20and%20warm%20amber%20poster%20walls%2C%20crowd%20silhouettes%2C%20premium%20entertainment%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg01&orientation=landscape",
    excerpt:
      "上映以来，《星际裂痕》凭借扎实的设定与克制的叙事收获大量好评，太空题材再次成为观众讨论的焦点。",
    content: [
      "上映以来，《星际裂痕》凭借扎实的世界观设定与克制的叙事节奏，收获了来自观众与影评人的一致好评。影片没有把重心放在炫目的特效堆砌上，而是把镜头对准了人在极端环境中的选择。",
      "有观众表示，影片最打动人的地方在于它对“孤独”与“连接”的刻画。宏大的宇宙背景下，主人公凯恩的每一次抉择都显得具体而真实，这种反差正是影片的魅力所在。",
      "业内分析认为，近年来太空科幻题材的持续升温，反映出观众对更具想象力和思辨性的内容的期待。随着更多同类作品筹备，这一类型的热度有望延续。",
    ],
    relatedMovieIds: ["mv-01", "mv-10", "mv-04"],
  },
  {
    id: "news-02",
    title: "《长夜将明》收官，年代剧如何讲好小人物的故事",
    category: "剧集观察",
    date: "2025-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20rainy%20old%20town%20street%20at%20dusk%20with%20warm%20streetlamps%20and%20deep%20blue%20sky%2C%20vintage%20architectural%20details%2C%20nostalgic%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg02&orientation=landscape",
    excerpt:
      "《长夜将明》正式收官，剧集用一群普通人的命运，诠释了年代题材最动人的底色。",
    content: [
      "随着最后一集播出，《长夜将明》正式收官。剧集没有把镜头留给宏大的历史场面，而是选择跟随一群普通年轻人，记录他们在动荡岁月里的坚持与守望。",
      "编剧团队在采访中提到，创作过程中他们最在意的，是让每一个角色都“站得住”。人物不再是推动情节的工具，而是有犹豫、有软弱、也会在关键时刻做出选择的真实个体。",
      "观众留言中，“克制”与“真诚”是被提及最多的词。也许正是这种不刻意煽情的表达，让年代剧重新找到了与当下观众对话的方式。",
    ],
    relatedMovieIds: ["mv-13", "mv-20", "mv-02"],
  },
  {
    id: "news-03",
    title: "秋季片单前瞻：多部重磅作品定档，类型更加多元",
    category: "档期动态",
    date: "2025-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20calendar%20and%20film%20reels%20on%20a%20desk%20with%20deep%20blue%20moody%20lighting%20and%20warm%20amber%20desk%20lamp%20glow%2C%20cinema%20planning%20concept%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg03&orientation=landscape",
    excerpt:
      "进入秋季，多部类型各异的影视作品陆续定档，科幻、悬疑、家庭题材均有亮点，观众选择更加丰富。",
    content: [
      "随着秋季档期开启，多部备受关注的作品陆续公布上映与播出计划。从目前公布的片单来看，今年的类型分布比往年更加均衡，科幻、悬疑、家庭、喜剧等题材都有代表作。",
      "有评论认为，观众口味的分化正在推动内容供给走向多元。过去“押注单一爆款”的思路正在被更精细的受众运营取代。",
      "对普通观众而言，这意味着更多可自由选择的内容。无论是想在周末享受一场视听盛宴，还是寻找一部适合全家观看的作品，都能在片单里找到答案。",
    ],
    relatedMovieIds: ["mv-06", "mv-10", "mv-03"],
  },
  {
    id: "news-04",
    title: "从《迷雾档案》看悬疑剧的叙事进阶",
    category: "剧集观察",
    date: "2025-09-22",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20dim%20investigation%20office%20with%20a%20wall%20of%20case%20files%20connected%20by%20red%20strings%2C%20deep%20blue%20shadows%20with%20warm%20task%20lamp%20light%2C%20mystery%20concept%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg04&orientation=landscape",
    excerpt:
      "《迷雾档案》用扎实的推理与细腻的人物弧光，为国产悬疑剧提供了新的叙事样本。",
    content: [
      "《迷雾档案》播出期间，关于剧情的讨论长期占据话题榜。与许多依赖反转的悬疑作品不同，这部剧把更多笔墨放在了人物动机的合理性上。",
      "剧集采用双线交织的结构，一边推进案件调查，一边回望人物的过往。两条线在关键节点交汇，让真相的揭露既在意料之外，也在情理之中。",
      "从创作层面看，这部剧的价值或许在于：它证明了悬疑不只需要巧妙的谜题，更需要对人性有耐心的观察。",
    ],
    relatedMovieIds: ["mv-16", "mv-03", "mv-12"],
  },
  {
    id: "news-05",
    title: "国漫崛起进行时：《灵剑山海》带动玄幻题材关注",
    category: "行业观察",
    date: "2025-09-01",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20illustration%20of%20misty%20floating%20mountains%20with%20glowing%20jade%20sword%20light%2C%20deep%20blue%20peaks%20with%20warm%20golden%20accents%2C%20Chinese%20fantasy%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg05&orientation=landscape",
    excerpt:
      "随着《灵剑山海》热度攀升，国产动画在玄幻题材上的表现引发行业关注，制作水准成为讨论重点。",
    content: [
      "《灵剑山海》播出后，精美的画面与流畅的动作设计获得不少观众认可。作品以山海灵气为背景，构建了一个兼具东方美学与想象力的世界。",
      "制作团队透露，为了呈现山海的层次感，美术组参考了大量传统山水画的构图与用色，再结合现代渲染技术进行还原。",
      "业内认为，国产动画正从“能看”向“好看”转变，观众的审美要求也在推动行业整体水准提升。",
    ],
    relatedMovieIds: ["mv-22", "mv-21", "mv-02"],
  },
  {
    id: "news-06",
    title: "《深海回声》幕后揭秘：如何营造真实的深海压迫感",
    category: "幕后花絮",
    date: "2025-08-19",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20deep%20ocean%20depths%20with%20faint%20teal%20bioluminescent%20glow%20and%20a%20submersible%20silhouette%2C%20deep%20blue%20abyss%2C%20mysterious%20underwater%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg06&orientation=landscape",
    excerpt:
      "《深海回声》凭借出色的氛围营造备受讨论，剧组分享了声音与光影设计背后的思路。",
    content: [
      "《深海回声》最令人印象深刻的，是那种几乎可以触摸到的深海压迫感。剧组表示，这一效果来自声音设计、光影与节奏的共同作用。",
      "音效团队介绍了他们在水下录音与低频处理上的尝试，希望通过声音让观众“坐立不安”，而不仅仅依靠画面惊吓。",
      "导演也提到，深海之所以适合作为惊悚的舞台，是因为它本身就是人类认知的边界，未知带来的想象往往比具象更可怕。",
    ],
    relatedMovieIds: ["mv-04", "mv-01", "mv-09"],
  },
  {
    id: "news-07",
    title: "《山野拾光》：一部关于和解与陪伴的温柔之作",
    category: "影评推荐",
    date: "2025-07-14",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20golden%20rice%20terraces%20in%20southern%20Chinese%20mountains%20at%20warm%20sunset%20with%20deep%20blue%20distant%20hills%2C%20peaceful%20rural%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg07&orientation=landscape",
    excerpt:
      "没有激烈冲突，也没有刻意煽情，《山野拾光》用最日常的细节讲述了一段祖孙之间的和解。",
    content: [
      "《山野拾光》是一部非常安静的影片。它把一个城里长大的少女与山村外婆相处的夏天，拍得像一段被阳光晒暖的记忆。",
      "影片最出色的地方在于对生活细节的捕捉：一顿饭、一次插秧、一句没有说出口的关心。情感不靠台词推动，而是藏在日常的褶皱里。",
      "看完之后，很多观众会想起自己的家人。这或许就是这部电影最温柔的力量——它不教育你，只是提醒你，别忘了回头看看。",
    ],
    relatedMovieIds: ["mv-05", "mv-19", "mv-11"],
  },
  {
    id: "news-08",
    title: "音乐综艺回潮：经典重绎为何总能打动观众",
    category: "综艺观察",
    date: "2025-08-08",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20warmly%20lit%20music%20stage%20with%20microphones%20and%20spotlights%2C%20deep%20blue%20stage%20with%20warm%20amber%20and%20orange%20lights%2C%20concert%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg08&orientation=landscape",
    excerpt:
      "音乐综艺重新成为话题中心，经典歌曲的重新演绎，让不同世代的观众找到了共同的记忆。",
    content: [
      "近年来，以经典歌曲重绎为核心的音乐综艺重新受到欢迎。节目让不同年代的歌手同台，用各自的风格重新诠释熟悉的作品。",
      "观众之所以被打动，或许不只是因为旋律本身，而是因为每一首歌都绑定着一段个人记忆。当熟悉的旋律再次响起，分享的欲望自然被唤醒。",
      "节目制片人表示，他们希望做的不是一个竞赛，而是一个让音乐与情感重新连接的舞台。",
    ],
    relatedMovieIds: ["mv-23", "mv-24", "mv-11"],
  },
  {
    id: "news-09",
    title: "悬疑题材竞争加剧，内容回归叙事本身",
    category: "行业观察",
    date: "2025-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20dark%20neon%20city%20alley%20with%20rain%20reflections%20and%20deep%20blue%20shadows%20plus%20warm%20orange%20neon%20signs%2C%20moody%20urban%20mystery%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg09&orientation=landscape",
    excerpt:
      "随着悬疑作品数量增加，观众的审美要求也在提升，扎实的叙事正在成为决定口碑的关键。",
    content: [
      "悬疑题材在过去几年迎来爆发式增长，但数量的增加也让观众变得更加挑剔。单纯依靠反转和噱头的作品，越来越难以获得认可。",
      "观察近一年的高分作品可以发现，它们的共同点是人物动机合理、节奏张弛有度、结尾能够自圆其说。",
      "这说明市场正在从“题材红利”走向“内容竞争”。谁能把故事讲扎实，谁才能走得更远。",
    ],
    relatedMovieIds: ["mv-18", "mv-12", "mv-09"],
  },
  {
    id: "news-10",
    title: "家庭题材为何常看不腻：真实情感才是长久吸引力",
    category: "影评推荐",
    date: "2025-07-28",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20cozy%20warm%20family%20dining%20table%20at%20evening%20with%20deep%20blue%20window%20dusk%20outside%20and%20warm%20amber%20lamp%20light%20inside%2C%20intimate%20home%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=newsimg10&orientation=landscape",
    excerpt:
      "无论类型如何变化，家庭题材始终拥有一批忠实观众，因为它讲述的是每个人都能共鸣的情感。",
    content: [
      "家庭题材看似平淡，却总能持续产出打动人心的作品。原因并不复杂：它面对的是每个人都无法回避的情感关系。",
      "优秀的家庭作品，往往不会给出标准答案，而是把选择的复杂性保留下来，让观众在角色的犹豫中看到自己。",
      "当制作越来越精良，真正稀缺的反而是这种真诚。也正因如此，家庭题材永远不会过时。",
    ],
    relatedMovieIds: ["mv-05", "mv-15", "mv-07"],
  },
];